//Please add the language resource
const loginLog = {
  username: 'username',
  ipAddress: 'ipAddress',
  address: 'address',
  browserName: 'browserName',
  operateSystem: 'operateSystem',
  loginStatus: 'loginStatus',
  operateMsg: 'operateMsg',
  createTime: 'createTime',
  msg: {}
};
export default loginLog



// WEBPACK FOOTER //
// ./src/page/log/loginLog/lang/loginLog.en.js